import React from 'react';
import { NavLink } from 'react-router-dom';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';

export default class TaskCalendar extends Base {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            tasks: [],
            year: 0,
            data:null,
            month: 0,
            weeks: []
        };
    }

    componentDidMount() {
        const today = new Date();
        this.setState({ year: today.getFullYear(), month: today.getMonth() + 1 }, () => this.loadTasks());
    }

    loadTasks() {
        this.setState({ loading: true });

        const start = new Date(this.state.year, this.state.month - 1, 1);
        const end = new Date(this.state.year, this.state.month, 0, 23, 59, 59);
        this.httpPost('api/v1/task/list', {
            page: 1,
            count: 500,
            phrase: '',
            filters: {
                dueDateFrom: start.toISOString(),
                dueDateTo: end.toISOString()
            }
        }).then(data => {
            if (data.status === 1) {
                const tasks = data.records;
                this.buildCalendar(tasks);
                this.setState({data:data, loading: false });

            } else {
                this.showErorrMessage(data.message);
                this.setState({ loading: false });
            }
        });
    }

    buildCalendar(tasks) {
        const { year, month } = this.state;
        const firstDay = new Date(year, month - 1, 1);
        const lastDay = new Date(year, month, 0);
        const weeks = [];
        let day = new Date(firstDay);
        day.setDate(day.getDate() - ((firstDay.getDay() + 1) % 7)); 

        while (day <= lastDay || weeks.length < 6) {
            const week = [];
            for (let i = 0; i < 7; i++) {
                const date = new Date(day);
                const dateStr = date.toISOString().split('T')[0];
                const dayTasks = tasks.filter(t => t.dueDate && t.dueDate.startsWith(dateStr));
                week.push({ date, day: date.getDate(), isCurrentMonth: date.getMonth() + 1 === month, tasks: dayTasks });
                day.setDate(day.getDate() + 1);
            }
            weeks.push(week);
        }
        this.setState({ weeks, loading: false });
    }

    changeMonth(delta) {
        let { year, month } = this.state;
        month += delta;
        if (month > 12) { month = 1; year++; }
        if (month < 1) { month = 12; year--; }
        this.setState({ year, month }, () => this.loadTasks());
    }

    renderForm() {
        const { loading, weeks, year, month, tasks } = this.state;
        if (loading) return this.renderLoading();

        const monthNames = ['فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'];
        return (
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <h3 className="nk-block-title page-title">تقویم وظایف</h3>
                        </div>
                        <div className="nk-block-head-content">
                            <div className="btn-group">
                                <button className="btn btn-outline-light" onClick={() => this.changeMonth(-1)}>قبلی</button>
                                <span className="btn btn-light disabled">{monthNames[month - 1]} {year}</span>
                                <button className="btn btn-outline-light" onClick={() => this.changeMonth(1)}>بعدی</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card card-bordered">
                    <div className="card-inner p-0">
                        <table className="table table-bordered calendar-table">
                            <thead>
                                <tr>
                                    <th>شنبه</th><th>یکشنبه</th><th>دوشنبه</th><th>سه‌شنبه</th><th>چهارشنبه</th><th>پنجشنبه</th><th>جمعه</th>
                                </tr>
                            </thead>
                            <tbody>
                                {weeks.map((week, i) => (
                                    <tr key={i}>
                                        {week.map((d, j) => (
                                            <td key={j} className={d.isCurrentMonth ? '' : 'text-muted'}>
                                                <div className="day-number">{d.day}</div>
                                                {d.tasks.map(task => (
                                                    <div key={task.id} className="mb-1">
                                                        <NavLink to={`/task/edit/${task.id}/`} className="badge badge-dim badge-primary">
                                                            {task.title.length > 15 ? task.title.substring(0, 15) + '...' : task.title}
                                                        </NavLink>
                                                    </div>
                                                ))}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        if (!this.isBlank(this.state.redirect)) return <NavLink to={this.state.redirect} />;
        let contents = this.state.loading ? this.renderLoading() : [
            <Header data={{ global: this.state.data?.global }} />,
            <div className="nk-content "><div className="container-fluid"><div className="nk-content-inner">{this.renderForm()}</div></div></div>,
            <Footer />
        ];
        return contents;
    }
}